import {createFileRoute, Outlet, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({context}) => {
    const auth = await context?.auth;
    if (!auth.user) {
      throw redirect({to: "/"});
    }
  },
  component: AuthRouteComponent,
});

function AuthRouteComponent() {
  return <Outlet />;
}
